import { render, staticRenderFns } from "./discount-total.vue?vue&type=template&id=7379be76&scoped=true"
import script from "./discount-total.vue?vue&type=script&lang=js"
export * from "./discount-total.vue?vue&type=script&lang=js"
import style0 from "./discount-total.vue?vue&type=style&index=0&id=7379be76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7379be76",
  null
  
)

export default component.exports